export class NavigationModel {
    public model: any[];
    constructor() {
        this.model = [];
    }
}



// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/navigation.model.ts